const LOGOS = [
  'Family Organizer',
  'Co-parenting Made Easy',
  'Real-time Sync',
  'Offline-first',
  'Privacy Focused',
  'AES-256 Encrypted',
  'Works on Any Device',
  'No Ads. Ever.',
]

export const SocialProofBar = () => (
  <section className="py-5 bg-primary overflow-hidden">
    <div className="flex whitespace-nowrap animate-ticker gap-0">
      {[...LOGOS, ...LOGOS].map((label, i) => (
        <span key={i} className="inline-flex items-center gap-2 text-white/80 text-sm font-medium px-8">
          <span className="w-1.5 h-1.5 bg-white/40 rounded-full" />
          {label}
        </span>
      ))}
    </div>
  </section>
)
